<div class="duplicate-orders-dialog">
  <div class="icon-container">
    <img src="assets/images/container-management/import-warning.png" alt="Warning" class="warning-image">
  </div>

  <div class="dialog-content">
    <p class="title">
      <b>
        These orders are already in the system and uploading will <br>
        be generate duplicated orders<br>
        Do you want to proceed ahead?
      </b>
    </p>

    <div class="order-list-section">
      <p class="order-list-label">Order List :</p>
      <p class="order-list-items">
        <ng-container *ngFor="let orderId of duplicateOrderIds; let i = index">
          Order No: {{ orderId }}<ng-container *ngIf="i < duplicateOrderIds.length - 1">, </ng-container>
        </ng-container>
      </p>
    </div>

    <div class="button-container">
      <button mat-button class="cancel-button" (click)="onCancel()">
        Cancel
      </button>
      <button mat-raised-button class="continue-button" (click)="onContinue()">
        Continue
      </button>
    </div>
  </div>
</div>

